import { useEffect, useState } from "react"
import { useAppSelector } from "app/hooks"
import { AIScanFoodOptionType, SearchFoodResultType } from "model/food/types"
import {
  isEdamaFood,
  isMyFood,
  isOpenFoodFactFood,
} from "model/food/utils/typeGuards/foodTypeGuards"
import { v4 as uuidv4 } from "uuid"

export const isManuallyAddedFoodsInAIFlow = (food: AIScanFoodOptionType) => {
  return isMyFood(food) || isEdamaFood(food) || isOpenFoodFactFood(food)
}

const useScanFlowFoodOptions = () => {
  const scanMealResults = useAppSelector((state) => state.meal.scanMealResults)
  const [foods, setFoods] = useState<AIScanFoodOptionType[]>(scanMealResults)

  useEffect(() => {
    setFoods(scanMealResults)
  }, [scanMealResults])

  const toggleSelectFood = (updatedFood: AIScanFoodOptionType) => {
    setFoods((foods) =>
      foods.map((food) => ({
        ...food,
        isSelected:
          food.uuid === updatedFood.uuid ? !food.isSelected : food.isSelected,
      })),
    )
  }

  const onUpdateFood = (updatedFood: AIScanFoodOptionType) => {
    const updatedFoods = foods.map((food) =>
      food.uuid === updatedFood.uuid ? updatedFood : food,
    )
    setFoods(updatedFoods)
  }

  const onAddFood = (food: SearchFoodResultType) => {
    const option: AIScanFoodOptionType = {
      ...food,
      isSelected: true,
      uuid: uuidv4(),
    }
    setFoods((prevFoods) => [...prevFoods, option])
  }

  const manuallyAddedFoods = foods.filter((food) => isManuallyAddedFoodsInAIFlow(food))

  const aiScanResultFoods = foods.filter((food) => !isManuallyAddedFoodsInAIFlow(food))

  return {
    foods,
    aiScanResultFoods,
    manuallyAddedFoods,
    toggleSelectFood,
    onUpdateFood,
    onAddFood,
  }
}

export default useScanFlowFoodOptions
